import {
  ProductImageBlock,
  ProductImageBlockProps,
  useCaseType,
} from '@rimactechnology/rimac-ui-lib';

import { ProductImageBlockFragment } from '@/api';
import getCdlPublicId from '@/hooks/useCdlPublicId';

type orientationType = 'imageLeft' | 'imageRight';

interface EnhancedProductImageBlockProps {
  productImageBlock?: ProductImageBlockFragment | null;
  orientation?: orientationType;
  titleMaxWidth?: number;
  parentIndex: number;
}

export default function EnhancedProductImageBlock({
  productImageBlock,
  orientation,
  titleMaxWidth,
  parentIndex,
}: EnhancedProductImageBlockProps) {
  const smallSpecTable = productImageBlock?.specTable?.data?.attributes;

  const productImageBlockProps: ProductImageBlockProps = {
    parentIndex: parentIndex || 1,
    orientation,
    titleMaxWidth,
    title: productImageBlock?.title || '',
    paragraphs: [productImageBlock?.subtitle || ''],
    galleryExtraText: productImageBlock?.galleryExtraText || '',
    anchor: productImageBlock?.anchor || undefined,
    images: (productImageBlock?.gallery || []).map((image) => ({
      imgSrc: getCdlPublicId(image?.img_desktop.data?.attributes?.url || ''),
      imgSrcMobile: getCdlPublicId(
        image?.img_mobile?.data?.attributes?.url || undefined,
      ),
      alt: image?.alt || '',
      blurHash: image?.img_desktop.data?.attributes?.blurhash || '12312312',
    })),
    button: productImageBlock?.button?.label
      ? {
          label: productImageBlock?.button?.label || '',
          path: productImageBlock?.button?.path || '',
          useCase: 'technology' as useCaseType,
          openInNewTab: !!productImageBlock?.button?.openInNewTab,
        }
      : undefined,
    largeSpecsTable: (productImageBlock?.largeSpec || []).map((spec) => ({
      label: spec?.label || '',
      value: spec?.value || '',
    })),
    denseSpecTable: productImageBlock?.denseSpecs?.length
      ? (productImageBlock?.denseSpecs || []).map((row) => ({
          title: row?.title || '',
          label: row?.label || '',
          value: row?.value || '',
          gapBellow: row?.gapBellow || false,
        }))
      : undefined,
    smallSpecTable: {
      parentIndex: parentIndex || 1,
      heading: {
        title: smallSpecTable?.heading?.title || '',
        subtitle: smallSpecTable?.heading?.subtitle || '',
      },
      title: smallSpecTable?.title || '',
      specs: (smallSpecTable?.specs || []).map((spec) => ({
        label: spec?.label || '',
        value: spec?.value || '',
      })),
      numOfItemsToShow: smallSpecTable?.numOfItemsToShow || undefined,
    },
  };

  return <ProductImageBlock {...productImageBlockProps} />;
}
